import GATSBY_COMPILED_MDX from "/drone/src/data/posts/2024/year-in-review.mdx";
import React, {useMemo, useState} from "react";
import {MDXProvider} from "@mdx-js/react";
import {Link} from "gatsby";
import {useDateFormatter} from "react-aria";
import {useSpring} from "@react-spring/web";
import "./PostTemplate.css";
import {PostsLayout} from "./PostsLayout";
import {PostImage} from "./PostImage";
import {PostImageGroup} from "./PostImageGroup";
import "bluesky-comments/bluesky-comments.css";
import {BlueskyComments} from "bluesky-comments";
const components = {
  Link,
  PostImage,
  PostImageGroup,
  h2(_ref) {
    let {children, ...props} = _ref;
    return React.createElement("h2", props, React.createElement("div", {
      className: "w-1/2 mx-auto border-t pt-4 border-slate-400"
    }), children);
  }
};
function PageTemplate(_ref2) {
  var _data$mdx2, _data$mdx2$tableOfCon, _data$mdx3, _data$mdx3$frontmatte, _data$mdx3$frontmatte2, _data$mdx3$frontmatte3, _data$mdx3$frontmatte4;
  let {data, children} = _ref2;
  const date = useMemo(() => {
    var _data$mdx, _data$mdx$frontmatter;
    return ((_data$mdx = data.mdx) === null || _data$mdx === void 0 ? void 0 : (_data$mdx$frontmatter = _data$mdx.frontmatter) === null || _data$mdx$frontmatter === void 0 ? void 0 : _data$mdx$frontmatter.date) && new Date(data.mdx.frontmatter.date);
  }, [data.mdx]);
  const df = useDateFormatter({
    timeZone: "utc"
  });
  const {0: activeEntry, 1: setActiveEntry} = useState(null);
  const tocEntries = (_data$mdx2 = data.mdx) === null || _data$mdx2 === void 0 ? void 0 : (_data$mdx2$tableOfCon = _data$mdx2.tableOfContents) === null || _data$mdx2$tableOfCon === void 0 ? void 0 : _data$mdx2$tableOfCon.items;
  const tocSpring = useSpring({
    top: activeEntry ? 0 : -200
  });
  return React.createElement(PostsLayout, {
    cover: (_data$mdx3 = data.mdx) === null || _data$mdx3 === void 0 ? void 0 : (_data$mdx3$frontmatte = _data$mdx3.frontmatter) === null || _data$mdx3$frontmatte === void 0 ? void 0 : (_data$mdx3$frontmatte2 = _data$mdx3$frontmatte.cover) === null || _data$mdx3$frontmatte2 === void 0 ? void 0 : (_data$mdx3$frontmatte3 = _data$mdx3$frontmatte2.childImageSharp) === null || _data$mdx3$frontmatte3 === void 0 ? void 0 : (_data$mdx3$frontmatte4 = _data$mdx3$frontmatte3.original) === null || _data$mdx3$frontmatte4 === void 0 ? void 0 : _data$mdx3$frontmatte4.src,
    description: data.mdx.excerpt,
    title: data.mdx.frontmatter.title
  }, React.createElement("div", {
    className: "mx-auto prose px-4"
  }, React.createElement("h1", {
    style: date ? {
      marginBottom: 0
    } : {}
  }, data.mdx.frontmatter.title), date && React.createElement("p", {
    style: {
      marginTop: 0
    }
  }, df.format(date)), React.createElement(MDXProvider, {
    components: components
  }, children), React.createElement("section", {
    className: "not-prose"
  }, React.createElement(BlueskyComments, {
    author: "chuckdries.com"
  }))));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(PageTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
const query = "3906971371";
